import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { AssignStoreMenusRequestSchema } from '~/services/api/generated'

const schema = AssignStoreMenusRequestSchema.strict()

export const MenuAssignStoreMenus = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  schema
